import apiWrapper from '../apiWrapprer'

const endpoints = {
  getListBounceRecipientTotalCounters: '/frontend/webMethods/Statistics.asmx/GetListBounceRecipientTotalCounters',
  getMessageHourCounters: '/frontend/webMethods/Statistics.asmx/GetMessageHourCounters',
  getMessageTotalCounters: '/frontend/webMethods/Statistics.asmx/GetMessageTotalCounters',
  getMessageUrlTotalCounters: '/frontend/webMethods/Statistics.asmx/GetMessageUrlTotalCounters',
  getMessageEventsBounces: '/frontend/webMethods/Statistics.asmx/GetMessageEventsBounces',
  getMessageRecipientsTotalCounters: '/frontend/webMethods/Statistics.asmx/GetMessageRecipientsTotalCounters',
  getSendingTotalCounters: '/frontend/webMethods/Statistics.asmx/GetSendingTotalCounters',
  getSendingRecipientsTotalCounters: '/frontend/webMethods/Statistics.asmx/GetSendingRecipientsTotalCounters'
}

export const getMessageRecipientsTotalCounters = (idList, guid, idmessage, pagesize, pagenumber, search, group, idrecipient, filter, orderby, orderdescending, dateFromUTC, dateToUTC) => {
  const url = endpoints.getMessageRecipientsTotalCounters

  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList, guid, idmessage, pagesize, pagenumber, search, group, idrecipient, filter, orderby, orderdescending, dateFromUTC, dateToUTC, getsendtrace: null, getbounce: null
    })
  }).then(extractData)
}

// public string GetSendingRecipientsTotalCounters(int idList, string guid, int idmessage, int idSending, int pagesize, int pagenumber, string search = null, long? group = null, long? idrecipient = null, string filter = null, string orderby = null, bool? orderdescending = null, bool? getsendtrace = null, bool? getbounce = null)

export const getSendingRecipientsTotalCounters = (idList, guid, idmessage, idSending, pagesize, pagenumber, search, group, idrecipient, filter, orderby, orderdescending) => {
  const url = endpoints.getSendingRecipientsTotalCounters

  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList, guid, idmessage, idSending, pagesize, pagenumber, search, group, idrecipient, filter, orderby, orderdescending, getsendtrace: null, getbounce: null
    })
  }).then(extractData)
}

export const getMessageEventsBounces = (idList, guid, idMessage, pageSize, pageNumber, dateFromUTC, dateToUTC, orderBy, orderdescending) => {
  const url = endpoints.getMessageEventsBounces
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList, guid, idMessage, pageSize, pageNumber, dateFromUTC, dateToUTC, orderBy, orderdescending
    })
  }).then(extractData)
}

export const getListBounceRecipientTotalCounters = (idList, guid, pagesize, pagenumber, idmessage) => {
  const url = endpoints.getListBounceRecipientTotalCounters
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      pagesize,
      pagenumber,
      idmessage,
      idsending: null,
      idrecipient: null,
      bouncetype: null,
      search: null,
      group: null,
      status: null,
      minbounce: null,
      orderby: null,
      orderdescending: null
    })
  }).then(extractData)
}

export const getMessageHourCounters = (idList, guid, idMessage, counterType, dateFromUTC, dateToUTC) => {
  const url = endpoints.getMessageHourCounters
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idMessage,
      counterType,
      dateFromUTC,
      dateToUTC
    })
  }).then(extractData)
}

export const getSendingTotalCounters = (idList, guid, idMessage, idSending, countersList) => {
  const url = endpoints.getSendingTotalCounters
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idMessage,
      idSending,
      countersList
    })
  }).then(extractData)
}

export const getMessageUrlTotalCounters = (idList, guid, idMessage, pageSize, pageNumber, types) => {
  const url = endpoints.getMessageUrlTotalCounters
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idMessage,
      pageSize,
      pageNumber,
      types
    })
  }).then(extractData)
}

export const getMessageTotalCounters = (idList, guid, idMessage, countersList, dateFromUTC, dateToUTC) => {
  const url = endpoints.getMessageTotalCounters
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idMessage,
      countersList,
      dateFromUTC,
      dateToUTC
    })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
